"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _ScriptManager = _interopRequireDefault(require("../../../utilities/ScriptManager"));

var scriptManager = new _ScriptManager.default();

var useSecureDocumentsWidget = function useSecureDocumentsWidget(url, props, options) {
  var rootRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var onError = options.onError,
      onLoad = options.onLoad;
  var loadWidget = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return scriptManager.loadComplete(url);

          case 4:
            setLoaded(true);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad();
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setError(_context.t0);
            onError === null || onError === void 0 ? void 0 : onError(_context.t0);

          case 12:
            _context.prev = 12;
            setLoading(false);
            return _context.finish(12);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8, 12, 15]]);
  })), [url, onError, onLoad]);
  (0, _react.useEffect)(function () {
    loadWidget();
  }, [loadWidget]);
  (0, _react.useEffect)(function () {
    var renderWidget = function renderWidget() {
      if (window.SecureDocumentsWidget) {
        var w = new window.SecureDocumentsWidget(props);

        if (rootRef.current) {
          w.render(rootRef.current);
        }
      }
    };

    renderWidget();
  }, [loaded, rootRef, props]);
  return [rootRef, {
    error: error,
    loading: loading,
    loaded: loaded
  }];
};

var _default = useSecureDocumentsWidget;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useSecureDocumentsWidget/useSecureDocumentsWidget.js
// module id = 1825
// module chunks = 0